<template>
  <page-view :title="false">
    <a-row :gutter="[10, 10]">
      <a-col
        :xs="8"
        :sm="6"
        :md="4"
        :lg="3"
        v-for="(item, idx) in dataList"
        :key="idx"
      >
        <a-badge
          :count="item.opened > 0 ? item.opened : ''"
          :offset="[-5, 3]"
          style="width: 100%;"
        >
          <a-card
            :bordered="false"
            :bodyStyle="{ padding: '10px', textAlign: 'center' }"
          >
            <h3
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
            >
              {{ item.descript }}
            </h3>
            <p style="font-size: 10px;color: grey;">代码({{ item.code }})</p>
            <div style="font-size: 10px;color: grey;">
              开通城市(<span
                :style="{
                  color: item.opened > 0 ? 'red' : 'grey',
                  'font-weight': item.opened > 0 ? 'bold' : '100'
                }"
                >{{ item.opened }}</span
              >)
              <a-divider type="vertical" />
              未通城市(<span>{{ item.closeed }}</span
              >)
            </div>

            <a style="padding-top: 10px;display: block;" @click="see(item)"
              >查看</a
            >
          </a-card>
        </a-badge>
      </a-col>
    </a-row>

    <!-- 弹出框 -->
    <a-modal v-model="modal.visible" :title="modal.title" @cancel="cancel">
      <!-- <template v-for="tag in cityList">
        <a-checkable-tag
          :key="tag.code"
          :checked="tag.isOpen == 'T' ? true : false"
        >
          {{ tag.descript }}
        </a-checkable-tag>
      </template> -->
      <template v-for="tag in cityList">
        <p style="display: inline-block;margin: 5px;" :key="tag.code">
          {{ tag.descript
          }}<a-switch
            checked-children="开"
            un-checked-children="关"
            :checked="tag.isOpen == 'T' ? true : false"
            @change="checkChange(tag)"
            style="margin-left: 5px;"
          />
        </p>
      </template>
      <template slot="footer">
        <a-button key="back" @click="cancel">取消</a-button>
      </template>
    </a-modal>
  </page-view>
</template>

<script>
import moment from "moment";
import { PageView } from "@/layouts";

export default {
  name: "ProvinceList",
  components: {
    PageView
  },
  data() {
    return {
      dataList: [],
      cityList: [],
      //弹出框参数
      modal: {
        visible: false,
        title: "城市"
      }
    };
  },
  created() {
    this.listCodeProvince();
  },
  methods: {
    listCodeProvince() {
      this.$http.systemBksApi.listCodeProvince({}).then(res => {
        this.dataList = res.resultObject;
      });
    },
    listCodeCity(code) {
      this.$http.systemBksApi
        .listCodeCity({
          provinceCode: code
        })
        .then(res => {
          this.cityList = res.resultObject;
        });
    },
    checkChange(tag) {
      let flag = "";
      if (tag.isOpen == "T") {
        flag = "F";
      } else {
        flag = "T";
      }
      let param = {};
      param.isOpen = flag;
      param.id = tag.id;
      param.code = tag.code;
      this.$http.systemBksApi.modifyCodeCity(param).then(res => {
        tag.isOpen = flag;
        this.$message.success(flag == "T" ? "开通成功" : "关闭成功");
        this.listCodeProvince();
      });
    },
    see(province) {
      this.modal.visible = true;
      this.listCodeCity(province.code);
    },
    cancel() {
      this.modal.visible = false;
    }
  }
};
</script>
